module.exports = __webpack_public_path__ + "static/media/batteryOrangeFilled.9fbdd503.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DevicesList/batteryOrangeFilled.svg
// module id = 828
// module chunks = 0